export default __webpack_public_path__ + "static/media/car.3fd2c1eb.pdf";